(function () {
	'use strict';
	$(document).ready(function () {

		if ($('.footer').length) {

			const swiperTrusted = new Swiper('.swiper-trusted', {
				slidesPerView: 2,
				spaceBetween: 16,
				loop: true,
				freeMode: true,
				speed: 3000,
				autoplay: {
					delay: 1,
					disableOnInteraction: false,
				},
				breakpoints: {
					1200: {
						slidesPerView: 5,
					},
					768: {
						slidesPerView: 4,
					},
					576: {
						slidesPerView: 3,
					}
				}
			});

		}

	});
}(jQuery));
